'use client'

import { Spinner } from '@/components/kibo-ui/spinner'
import { cn } from '@/lib/utils'

interface SignInLoggedInNotificationProps {
  message: string
  isPending?: boolean
  className?: string
}

export function SignInLoggedInNotification({
  message,
  isPending = false,
  className,
}: SignInLoggedInNotificationProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy={isPending}
      className={cn(
        'corner-squircle animate-in fade-in slide-in-from-bottom-2 fill-mode-both flex items-center gap-2.5 rounded-lg border border-brand/25 bg-brand/10 px-3.5 py-3 text-sm text-brand duration-500',
        className,
      )}
    >
      <Spinner
        variant="pinwheel"
        size={16}
        className="text-brand shrink-0"
        aria-hidden
      />
      <span className="text-pretty font-medium">{message}</span>
    </div>
  )
}
